import DF from '@/lib/define';
// axios を require してインスタンスを生成する
const axiosBase = require('axios');

const axios = axiosBase.create({
  baseURL: `${DF.API_URL}`,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  responseType: 'json',
});

function loader (vue) {
  const my = this;
  // ===========================================================================
  // private var
  // ===========================================================================
  // 送信データオブジェクト
  var post_data = null;
  // ===========================================================================
  // public var
  // ===========================================================================
  // コールバック関数
  my._post_cb_f = null;
  // 本通信クラスでのエラー表示時用コールバック
  my._err_cb_func = null;
  // ===========================================================================
  // private function
  // ===========================================================================
  function data_set (obj) {
    // torken情報埋め込み
    obj.token = vue.$store.getters['uLoginInfo/login_token'];
    // POSTデータ(json)生成
    post_data = JSON.stringify(obj);
  }
  // manage用data_set
  function m_data_set (obj) {
    // torken情報埋め込み
    obj.token = vue.$store.getters['mLoginInfo/login_token'];
    // POSTデータ(json)生成
    post_data = JSON.stringify(obj);
  }

  function load_start (url) {
    if (!window.navigator.onLine) {
      vue.$alert('alert', vue.$DF.MESSEGE_ERR_NETWORK);
      if (my._err_cb_func !== null) {
        my._err_cb_func();
      }
      return;
    }

    vue.$store.commit('loading/set_loading', true);
    axios.post('', {
      data: post_data,
      module: url,
    })
      .then((response) => {
        vue.$store.commit('loading/set_loading', false);
        if (response.data.res === vue.$DF.RES_OK) {
          // コールバック実行
          if (my._post_cb_f !== null) {
            my._post_cb_f(response.data);
          }
        } else if (response.data.res === vue.$DF.RES_LOGIN_ERR) {
          // セキュリティエラー
          vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_LOGIN}`);
        } else if (response.data.res === vue.$DF.RES_PAY_ERR) {
          // セキュリティエラー
          vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_PAY}`);
        } else {
          // その他のエラー
          // コールバック実行
          if (my._post_cb_f !== null) {
            my._post_cb_f(response.data);
          }
        }
      })
      .catch((error) => {
        vue.$store.commit('loading/set_loading', false);
        vue.$alert('alert', `${vue.$DF.MESSEGE_ERR_COMM}\n\n[${error}]`);
        if (my._err_cb_func !== null) {
          my._err_cb_func();
        }
      });
  }
  //==============================================================================================
  //public function
  //==============================================================================================
  this._data_set = data_set;
  this._m_data_set = m_data_set;
  this._load_start = load_start;
}
export default loader;
